<template>
  <div class="relative">
    <section class="bg-secondary-light rounded-xl py-10 px-7 lg:py-12 lg:px-16 divide-y divide-secondary-dark relative z-10">
      <PodcastPlayer
        v-for="podcast in Object.values(podcasts)"
        :key="podcast.title"
        :podcast="podcast"
        :episode="podcast.items[0]"
        class="pt-10 pb-10 first:pt-0 last:pb-0"
      />
    </section>
    <UtilityFishImage
      class="absolute -bottom-24 right-1/2 w-[144px] h-[144px] transform translate-x-1/2 lg:translate-x-0 lg:-bottom-52 lg:-right-32 -rotate-[14deg] lg:w-[350px] lg:h-[350px] text-secondary-light"
    />
  </div>
</template>
<script setup lang="ts">
defineProps({
  podcasts: {
    type: Object,
    required: true,
  },
})
</script>
